import { render, staticRenderFns } from "./RemoveContactModal.vue?vue&type=template&id=7ac16d3c&scoped=true&"
import script from "./RemoveContactModal.vue?vue&type=script&lang=js&"
export * from "./RemoveContactModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ac16d3c",
  null
  
)

export default component.exports